import clsx from "clsx";
import { X } from "lucide-react";
import { DetailsPanelProps } from "./types";

export const DetailsPanel = ({
  open,
  title,
  children,
  onClose,
  className,
  panelClassName,
  footer,
}: DetailsPanelProps) => {
  if (!open) return null;

  return (
    <div className={className}>
      <div
        className={clsx(
          "rounded-xl bg-white p-3 shadow-lg ring-1 ring-black/5",
          panelClassName,
        )}
      >
        {title && (
          <div className="mb-4 flex items-start justify-between gap-3">
            {title && (
              <h2 className="text-base font-semibold text-gray-900 break-all">
                {title}
              </h2>
            )}
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                aria-label="Close"
                className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-900/20"
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        )}
        <div className="space-y-4">{children}</div>
        {footer && <div className="mt-6 flex justify-end">{footer}</div>}
      </div>
    </div>
  );
};
